module.exports = __webpack_public_path__ + "static/media/ipc-logo.4056cc62.jpg";